import { render, staticRenderFns } from "./textarea-secondary.vue?vue&type=template&id=a744b2f8&scoped=true&"
import script from "./textarea-secondary.vue?vue&type=script&lang=js&"
export * from "./textarea-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a744b2f8",
  null
  
)

export default component.exports